import { observer } from "mobx-react-lite";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import React, { useState } from "react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const AssessFacilityQuality: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);
  
  const renderAccordionPlans = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}StartEarly.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >START EARLY</p>
                  <Header.Subheader>  
                    <p className={styles.learnMoreAccordionText} >
                      <b>Start looking before a facility is needed.</b> <br/>Giving yourself adequate time to find a 
                        facility will allow you to dig deep and not make any impulsive decisions. Preparing for these 
                        situations ahead of time can make a huge difference in finding the right place for the older adult.</p>  
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column width={4} stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}CompileAList.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >COMPILE A LIST </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                    Start making a list of places you find or places that have been recommended to you. You can add notes as you go so when it comes time to decide, you will have all the information you need in one place.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}QuestionAndAnswer.svg`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >PLAN QUESTIONS</p> 
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                      <b>Figure out what questions to ask.</b>  <br/>It is important to consider the older adult when planning about their future residence. Putting together a list of questions to ask the facility will be helpful when choosing a place. These questions can include things about the physical space (room sizes, amenities), what type of care is included, costs, waiting lists, etc.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'plans',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips on Finding a Facility </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionPlans()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}Facility2.jpeg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(AssessFacilityQuality);
